// extracted by mini-css-extract-plugin
module.exports = {"title_group":"TitleFlex_title_group__3J5Vy","title_container":"TitleFlex_title_container__2AjKt","title":"TitleFlex_title__3Rtqa","sub_title":"TitleFlex_sub_title__2hx1g"};